import styled from "styled-components";

export const ButtonAction = styled.button`
  margin-right: 2px;
  color: blue;
  font-size: 0.875rem;
  border: 0px;
  background: transparent;

  &:hover {
    color: blue;
    font-size: 0.875rem;
  }
`;

export const Icon = styled.i`
  margin-right: 10px;
  color: #f9ae17;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;
